export const actions = {
    APP_LAUNCH: 'APP_LAUNCH',
    APP_LAUNCH_FINISHED: 'APP_LAUNCH_FINISHED',
    REFRESH_APP: 'REFRESH_APP',
    REFRESH_APP_SUCCESS: 'REFRESH_APP_SUCCESS',
    REFRESH_APP_FAILED: 'REFRESH_APP_FAILED',

    GET_GUEST_TOKEN: 'GET_GUEST_TOKEN',
    GET_GUEST_TOKEN_SUCCESS: 'GET_GUEST_TOKEN_SUCCESS',
    GET_GUEST_TOKEN_FAILED: 'GET_GUEST_TOKEN_FAILED',

    GET_MFA_AUTH_FAILED: 'GET_MFA_AUTH_FAILED',
    GET_MFA_RESEND_CODE_FAILED: 'GET_MFA_RESEND_CODE_FAILED',
    AUTH_LOADING: 'AUTH_LOADING',
    RESET_MFA_ERROR: 'RESET_MFA_ERROR',

    MFA_AUTH: 'MFA_AUTH',
    MFA_VERIFY: 'MFA_VERIFY',
    OTP_GENERATE_SUCCESS: 'OTP_GENERATE_SUCCESS',

    GET_TOKENS_START: 'GET_TOKENS_START',
    GET_TOKENS_SUCCESS: 'GET_TOKENS_SUCCESS',
    GET_TOKENS_FAILED: 'GET_TOKEN_FAILED',

    LOGIN: 'LOGIN',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGIN_CANCELLED: 'LOGIN_CANCELLED',
    LOGIN_WITH_FB: 'LOGIN_WITH_FB',
    FACEBOOK_LOGIN_SUCCESS: 'FACEBOOK_LOGIN_SUCCESS',
    FACEBOOK_LOGIN_FAILED: 'FACEBOOK_LOGIN_FAILED',
    GETTING_FACEBOOK_RESPONSE: 'GETTING_FACEBOOK_RESPONSE',
    FACEBOOK_RESPONSE_COMPLETE: 'FACEBOOK_RESPONSE_COMPLETE',
    NEW_USER_FACEBOOK: 'NEW_USER_FACEBOOK',
    RESET_NEW_USER_FACEBOOK: 'RESET_NEW_USER_FACEBOOK',
    SEND_RESET_PASSWORD_EMAIL: 'SEND_RESET_PASSWORD_EMAIL',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILED: 'RESET_PASSWORD_FAILED',
    RESET_PASSWORD_MESSAGE: 'RESET_PASSWORD_MESSAGE',
    LOGOUT: 'LOGOUT',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILED: 'LOGOUT_FAILED',
    CLEAR_FORM_ERRORS: 'CLEAR_USER_ACCOUNT_ERRORS',
    REVOKE_TOKEN: 'REVOKE_TOKEN',

    GET_TERMS_AND_PRIVACY_UPDATE: 'GET_TERMS_AND_PRIVACY_UPDATE',
    GET_TERMS_AND_PRIVACY_UPDATE_FAILURE: 'GET_TERMS_AND_PRIVACY_UPDATE_FAILURE',
    SET_UPDATED_TERMS_AND_CONDITIONS: 'SET_UPDATED_TERMS_AND_CONDITIONS',
    SET_UPDATED_PRIVACY_POLICY: 'SET_UPDATED_PRIVACY_POLICY',
    PATCH_UPDATED_TERMS_AND_PRIVACY: 'PATCH_UPDATED_TERMS_AND_PRIVACY',
    PATCH_UPDATED_TERMS_AND_PRIVACY_SUCCESS: 'PATCH_UPDATED_TERMS_AND_PRIVACY_SUCCESS',
    PATCH_UPDATED_TERMS_AND_PRIVACY_FAILURE: 'PATCH_UPDATED_TERMS_AND_PRIVACY_FAILURE',
    SET_DISPLAY_TnC_MODAL: 'SET_DISPLAY_TnC_MODAL',

    SIGN_OUT: 'SIGN_OUT',
    SIGN_OUT_SUCCESS: 'SIGN_OUT_SUCCESS',
    SIGN_OUT_FAILED: 'SIGN_OUT_FAILED',

    CHECK_ORDER_FEEDBACK_FAILED: 'CHECK_ORDER_FEEDBACK_FAILED',
    MOBILE_BRIDGE_APP_LAUNCH_SUCCESS: 'MOBILE_BRIDGE_APP_LAUNCH_SUCCESS',

    CLEAR_CLIENT_TOKEN: 'CLEAR_CLIENT_TOKEN',
}

export const getTokensStart = () => ({
    type: actions.GET_TOKENS_START,
})

export const getTokensSuccess = receivedTokens => ({
    type: actions.GET_TOKENS_SUCCESS,
    payload: receivedTokens,
})

export const getTokensFailed = () => ({
    type: actions.GET_TOKENS_FAILED,
})

export const appLaunch = (accessToken, refreshToken) => ({
    type: actions.APP_LAUNCH,
    access: accessToken,
    refresh: refreshToken,
})

export const getTermsAndPrivacyUpdate = () => ({
    type: actions.GET_TERMS_AND_PRIVACY_UPDATE,
})

export const getTermsAndPrivacyUpdateFailure = error => ({
    type: actions.GET_TERMS_AND_PRIVACY_UPDATE_FAILURE,
    payload: error,
})

export const setDisplayTnCModal = payload => ({
    type: actions.SET_DISPLAY_TnC_MODAL,
    payload,
})

export const setUpdatedTermsAndConditions = updatedTerms => ({
    type: actions.SET_UPDATED_TERMS_AND_CONDITIONS,
    payload: updatedTerms,
})

export const mfaAuthFailed = payload => ({
    type: actions.GET_MFA_AUTH_FAILED,
    payload,
})

export const resetMFAError = () => ({
    type: actions.RESET_MFA_ERROR,
})

export const mfaResendCodeFailed = payload => ({
    type: actions.GET_MFA_RESEND_CODE_FAILED,
    payload,
})

export const authLoading = payload => ({
    type: actions.AUTH_LOADING,
    payload,
})

export const mfaAuth = request => ({
    type: actions.MFA_AUTH,
    payload: request,
})

export const mfaVerify = request => ({
    type: actions.MFA_VERIFY,
    payload: request,
})

export const otpGenerateSuccess = payload => ({
    type: actions.OTP_GENERATE_SUCCESS,
    payload,
})

export const setUpdatedPrivacyPolicy = updatedPrivacy => ({
    type: actions.SET_UPDATED_PRIVACY_POLICY,
    payload: updatedPrivacy,
})

export const patchUpdatedTermsAndPrivacy = updatedIds => ({
    type: actions.PATCH_UPDATED_TERMS_AND_PRIVACY,
    payload: updatedIds,
})

export const patchUpdatedTermsAndPrivacySuccess = payload => ({
    type: actions.PATCH_UPDATED_TERMS_AND_PRIVACY_SUCCESS,
    payload,
})

export const patchUpdatedTermsAndPrivacyFailure = payload => ({
    type: actions.PATCH_UPDATED_TERMS_AND_PRIVACY_FAILURE,
    payload,
})

export const appLaunchFlowComplete = () => ({
    type: actions.APP_LAUNCH_FINISHED,
})

export const refreshApp = (payload) => ({
    type: actions.REFRESH_APP,
    payload
})

export const refreshAppSuccess = (payload) => ({
    type: actions.REFRESH_APP_SUCCESS,
    payload
})

export const refreshAppFailed = (payload) => ({
    type: actions.REFRESH_APP_FAILED,
    payload
})

export const getGuestToken = () => ({
    type: actions.GET_GUEST_TOKEN,
})

export const getGuestTokenSuccess = () => ({
    type: actions.GET_GUEST_TOKEN_SUCCESS,
})

export const getGuestTokenFailed = () => ({
    type: actions.GET_GUEST_TOKEN_FAILED,
})

export const login = request => ({
    type: actions.LOGIN,
    payload: request,
})

export const loginSuccess = () => ({
    type: actions.LOGIN_SUCCESS,
})

export const loginFailed = error => ({
    type: actions.LOGIN_FAILED,
    payload: error,
})

export const signOut = history => ({
    type: actions.SIGN_OUT,
    navigate: history,
})

export const signOutSuccess = () => ({
    type: actions.SIGN_OUT_SUCCESS,
})

export const signOutFailed = error => ({
    type: actions.SIGN_OUT_FAILED,
    payload: error,
})

export const loginCancelled = () => ({
    type: actions.LOGIN_CANCELLED,
})

export const loginWithFb = response => ({
    type: actions.LOGIN_WITH_FB,
    payload: response,
})

export const facebookLoginSuccess = response => ({
    type: actions.FACEBOOK_LOGIN_SUCCESS,
    payload: response,
})

export const facebookLoginFailed = error => ({
    type: actions.FACEBOOK_LOGIN_FAILED,
    payload: error,
})

export const sendResetPasswordEmail = (email, callback) => ({
    type: actions.SEND_RESET_PASSWORD_EMAIL,
    payload: { email, callback },
})

export const ResetPasswordMessage = message => ({
    type: actions.RESET_PASSWORD_MESSAGE,
    payload: message,
})
export const ResetPasswordSuccess = () => ({
    type: actions.RESET_PASSWORD_SUCCESS,
})

export const ResetPasswordFailed = error => ({
    type: actions.RESET_PASSWORD_FAILED,
    payload: error,
})
export const logout = () => ({
    type: actions.LOGOUT,
})

export const logoutSuccess = () => ({
    type: actions.LOGOUT_SUCCESS,
})

export const logoutFailed = error => ({
    type: actions.LOGOUT_FAILED,
    payload: error,
})

export const clearFormErrors = () => ({
    type: actions.CLEAR_FORM_ERRORS,
})

export const gettingFacebookResponse = () => ({
    type: actions.GETTING_FACEBOOK_RESPONSE,
})

export const facebookResponseComplete = () => ({
    type: actions.FACEBOOK_RESPONSE_COMPLETE,
})

export const resetNewUserFacebook = payload => ({
    type: actions.RESET_NEW_USER_FACEBOOK,
    payload,
})

export const newUserFacebook = payload => ({
    type: actions.NEW_USER_FACEBOOK,
    payload,
})

export const checkOrderFeedbackFailed = error => ({
    type: actions.CHECK_ORDER_FEEDBACK_FAILED,
    payload: error,
})

export const MobileBridgeAppLaunchSuccess = payload => ({
    type: actions.MOBILE_BRIDGE_APP_LAUNCH_SUCCESS,
    payload,
})

export const revokeToken = payload => ({
    type: actions.REVOKE_TOKEN,
    payload,
})
